import { produce } from 'immer';

import { RecentFilterSearch } from '@/hygiene/components/flexible-content/RecentSearch/RecentSearch.type';
import { FilterOption } from '@/plp/components/PlpFilters/PlpFilters.type';

import { addRecentSearchFilter, removeFilterFromFilters } from './recentFilterSearch.helper';
import { storeFactory } from './storeFactory';

export interface RecentSearchFilterStoreStateData {
  recentFilterSearches: RecentFilterSearch[];
}

interface RecentSearchFilterStoreStateFunctions {
  removeFilterSearch: (search: RecentFilterSearch) => Promise<void>;
  addFilterSearch: (filters: FilterOption[]) => Promise<void>;
}

const {
  store: recentFilterSearchStore,
  StoreProvider: RecentFilterSearchStoreProvider,
  useCreateStore: useCreateRecentFilterSearchStore,
} = storeFactory<RecentSearchFilterStoreStateData, RecentSearchFilterStoreStateFunctions>(
  () => ({
    recentFilterSearches: [],
  }),
  (set) => ({
    removeFilterSearch: async (search: RecentFilterSearch) => {
      set((state) => {
        return produce(state, (draft) => {
          draft.recentFilterSearches = removeFilterFromFilters(state.recentFilterSearches, search);
        });
      });
    },
    addFilterSearch: async (filters: FilterOption[]) => {
      set((state) => {
        return produce(state, (draft) => {
          const { updated, recentSearches } = addRecentSearchFilter(filters, state.recentFilterSearches);
          if (updated && recentSearches) {
            draft.recentFilterSearches = recentSearches;
          }
        });
      });
    },
  }),
  'recentFilterSearchStore',
  1,
);

export { recentFilterSearchStore, RecentFilterSearchStoreProvider, useCreateRecentFilterSearchStore };
